import { render, staticRenderFns } from "./autocomplete-id.html?vue&type=template&id=9b122666&"
import script from "./autocomplete-id.ts?vue&type=script&lang=js&"
export * from "./autocomplete-id.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports